import { AbstractControl, ValidationErrors } from '@angular/forms';
import { hasInvalidListEmail, isEmailValid } from '@masar/common/utils';

export function emailValidator(
    control: AbstractControl
): ValidationErrors | null {
    const value = control.value?.toString();

    if (!value?.trim()) {
        return null;
    }

    return isEmailValid(value) ? null : { email: true };
}

export function listItemsEmailValidator(
    control: AbstractControl
): ValidationErrors | null {
    if (!Array.isArray(control.value)) {
        return null;
    }

    return hasInvalidListEmail(control.value) ? { email: true } : null;
}
